import React from "react";
import infoGreen from 'assets/images/account-page/info-green.svg';
import marketingAnnualIcon from 'assets/images/plan-marketing-annual.svg';
import classNames from "classnames";
import css from "../style.scss";
import { useDispatch, useSelector } from "react-redux";
import { selectPlanDetails, updateSelectedChooseTierTooltip } from "../../../../data/user";
import { useRef, useEffect } from "react";

const AnnualEliteIncludes = () => {
    const dispatch = useDispatch();
    const planDetails = useSelector(selectPlanDetails)?.toJS();
    const containerRef = useRef(null);

    const handleTooltipToggle = (tooltipId) => {
        const tooltipComponentId = `annualElite-${tooltipId}`;
        dispatch(updateSelectedChooseTierTooltip(tooltipComponentId));
    };

    useEffect(() => {
        return () => {
            dispatch(updateSelectedChooseTierTooltip(""));
        };
    }, []);
    return (
         <div className={css.clsInfoPopup} ref={containerRef}>
            <li>
                <img src={marketingAnnualIcon} className={css.clsIncludesIcon} alt="Marketing Credit Bonus" />
                <p>
                    <strong>Marketing Credit Bonus: </strong>
                    $150
                    <span className={css.clsInfoIcon} onClick={() => handleTooltipToggle('lead')}>
                        <img src={infoGreen} alt="info" />
                        <div className={classNames(css.clsInfoPopupContent, css.clsInfoPopupRight, {
                            [css.clsOpenPopup]: planDetails?.selectedChooseTierTooltip === 'annualElite-lead',
                        })}>
                            <h6 className={css.clsInfoContentTitle}>Marketing Credit Bonus: <span className={css.clsCloseIcon} onClick={(e) => { e.stopPropagation(); handleTooltipToggle(''); }}>&times;</span></h6>
                            <p className={css.clsInfoContentPara}>This one time <b>marketing credit</b> can help simplify your outreach with credits you can use for skip tracing, emails, or postcards. It’s a flexible way to connect with leads and keep your marketing efforts moving forward.</p>
                        </div>
                    </span>
                </p>
            </li>
        </div>
    )
}

export default AnnualEliteIncludes;
